import PropTypes from 'prop-types';
import { isEmpty, uniqueId } from 'lodash';
import Icon from "../../Icon/Icon";
import AllOrOne from "../../AllOrOne/AllOrOne";
import EmailAddress from "../../Contact/EmailAddress/EmailAddress";
import HoursOfOperation from "../../HoursOfOperation/HoursOfOperation";
import addresses from "../../../utils/Addresses";
import phones from "../../../utils/Phones";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Location = props => {
  const {
    addressCount = null,
    className = '',
    clickableAddress = false,
    disableEmailLink = false,
    disablePhoneLink = false,
    hideLabels = false,
    isInNetworkGroup = true,
    originLatLng = [],
    showHours = true,
    showHoursIcon = false,
    showMore = false,
    stopEventPropagation = false,
    additionalContentComponent = null,
    intlProvider = {}
  } = props;
  const location = addresses.calculateDistance(props.location, originLatLng);
  const locationAddress = loc => !isEmpty(originLatLng) ? "".concat(loc.displayName, " (").concat(loc.distance, ")") : "".concat(loc.displayName);
  const locationAddressWithLink = () => clickableAddress ? /*#__PURE__*/_jsx("a", {
    href: addresses.makeGoogleMapLink(location),
    rel: "noopener noreferrer",
    target: "_blank",
    className: "locations-address-link",
    children: locationAddress(location)
  }) : locationAddress(location);
  const formattedPhoneNumber = phoneNumber => !hideLabels && phoneNumber.phone_type ? "".concat(phoneNumber.phone_type, ": ").concat(phones.formatPhoneNumber(phoneNumber.phone_number)) : phones.formatPhoneNumber(phoneNumber.phone_number);
  const AdditionalContentComponent = additionalContentComponent;
  return /*#__PURE__*/_jsxs("div", {
    className: "location ".concat(className),
    onClick: e => {
      if (stopEventPropagation) {
        e.stopPropagation();
      }
    },
    children: [/*#__PURE__*/_jsxs("div", {
      className: "location-address items-start flex",
      children: [/*#__PURE__*/_jsx(Icon, {
        className: "location-icon mr-2 flex-1.5",
        color: "".concat(isInNetworkGroup ? 'action-blue' : 'brand-blue'),
        icon: "MapPin",
        size: 18
      }), /*#__PURE__*/_jsxs("div", {
        className: "location-content leading-6 pl-1 text-sm text-text-blue",
        children: [!hideLabels && location.name ? location.name : /*#__PURE__*/_jsxs("p", {
          className: "location-address-name flex flex-wrap capitalize",
          children: [/*#__PURE__*/_jsx("span", {
            className: "mr-2",
            children: locationAddressWithLink(location)
          }), /*#__PURE__*/_jsx("span", {
            className: "location-address-name-more text-action-blue",
            children: !isEmpty(addressCount) ? addressCount : ''
          })]
        }), !hideLabels && location.name && /*#__PURE__*/_jsxs("p", {
          className: "location-address items-start flex",
          children: [/*#__PURE__*/_jsx("span", {
            className: "mr-2",
            children: locationAddressWithLink(location)
          }), /*#__PURE__*/_jsx("span", {
            className: "location-address-name-more text-action-blue",
            children: !isEmpty(addressCount) ? addressCount : ''
          })]
        }), /*#__PURE__*/_jsx(AllOrOne, {
          showAll: showMore,
          children: !isEmpty(location.phone_numbers) && location.phone_numbers.map(phoneNumber => /*#__PURE__*/_jsx("p", {
            className: "location-phone capitalize",
            children: disablePhoneLink ? formattedPhoneNumber(phoneNumber) : /*#__PURE__*/_jsx("a", {
              href: phones.getTelLink(phoneNumber),
              target: "_blank",
              tabIndex: 0,
              rel: "noopener noreferrer",
              className: "text-action-blue",
              children: formattedPhoneNumber(phoneNumber)
            })
          }, "phone-".concat(phoneNumber.phone_number)))
        }), /*#__PURE__*/_jsx(AllOrOne, {
          showAll: showMore,
          children: !isEmpty(location.email_addresses) && location.email_addresses.map(email => /*#__PURE__*/_jsx("p", {
            className: "location-email",
            children: /*#__PURE__*/_jsx(EmailAddress, {
              className: "program-details-email-text",
              disableLink: disableEmailLink,
              emailAddress: email
            })
          }, "email-".concat(email)))
        })]
      })]
    }, uniqueId(location.name || location.displayName)), showHours && /*#__PURE__*/_jsx("div", {
      className: "location-hours pl-1",
      children: /*#__PURE__*/_jsx(HoursOfOperation, {
        hours: location.hours || location.hours_of_operation,
        isInNetworkGroup: isInNetworkGroup,
        showAll: showMore,
        showHoursIcon: showHoursIcon,
        showToggle: true,
        intlProvider: intlProvider
      })
    }), additionalContentComponent && /*#__PURE__*/_jsx(AdditionalContentComponent, {
      location: location
    })]
  });
};
Location.propTypes = {
  addressCount: PropTypes.string,
  className: PropTypes.string,
  clickableAddress: PropTypes.bool,
  disableEmailLink: PropTypes.bool,
  disablePhoneLink: PropTypes.bool,
  hideLabels: PropTypes.bool,
  isInNetworkGroup: PropTypes.bool,
  location: PropTypes.object.isRequired,
  originLatLng: PropTypes.array,
  showHours: PropTypes.bool,
  showHoursIcon: PropTypes.bool,
  showMore: PropTypes.bool,
  stopEventPropagation: PropTypes.bool,
  /**
   * Property to pass a component that will render in the main content area of the component.
   * This feature is used to render an edit location link.
   */
  additionalContentComponent: PropTypes.func,
  intlProvider: PropTypes.object
};
export default Location;
//# sourceMappingURL=Location.js.map